/* Yukon Bags · answer-first collection page: filters, show-all, sort */
(function () {
  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ycp-card]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-ycp-filter]'));
    var more = root.querySelector('[data-ycp-more]');
    var countEl = root.querySelector('[data-ycp-count]');
    var emptyEl = root.querySelector('[data-ycp-empty]');
    var sortEl = root.querySelector('[data-ycp-sort]');
    var initial = parseInt(root.getAttribute('data-initial'), 10) || 12;
    var labelAll = root.getAttribute('data-label-all');
    var labelFiltered = root.getAttribute('data-label-filtered');
    var state = { filter: 'all', expanded: false };

    function matches(card, f) {
      if (f === 'all') return true;
      return (' ' + (card.getAttribute('data-keys') || '') + ' ').indexOf(' ' + f + ' ') > -1;
    }

    function render() {
      var matched = 0;
      var limit = state.filter === 'all' && !state.expanded ? initial : Infinity;
      cards.forEach(function (card) {
        var ok = matches(card, state.filter);
        if (ok) matched += 1;
        card.hidden = !(ok && matched <= limit);
      });
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ycp-filter') === state.filter ? 'true' : 'false');
      });
      if (more) more.hidden = !(state.filter === 'all' && !state.expanded && matched > initial);
      if (emptyEl) emptyEl.hidden = matched !== 0;
      if (countEl) {
        countEl.textContent = state.filter === 'all'
          ? labelAll
          : labelFiltered.replace('[n]', matched).replace('[t]', cards.length);
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        state.filter = b.getAttribute('data-ycp-filter');
        render();
        if (history.replaceState) {
          var hash = state.filter === 'all' ? '' : '#' + b.getAttribute('data-slug');
          history.replaceState(null, '', location.pathname + location.search + hash);
        }
      });
    });

    if (more) {
      more.querySelector('button').addEventListener('click', function () {
        state.expanded = true;
        render();
      });
    }

    if (sortEl) {
      sortEl.addEventListener('change', function () {
        var params = new URLSearchParams(location.search);
        params.set('sort_by', sortEl.value);
        params.delete('page');
        location.search = params.toString();
      });
    }

    if (location.hash.length > 1) {
      var slug = decodeURIComponent(location.hash.slice(1));
      buttons.forEach(function (b) {
        if (b.getAttribute('data-slug') === slug) state.filter = b.getAttribute('data-ycp-filter');
      });
    }
    render();
  }
  Array.prototype.forEach.call(document.querySelectorAll('.ycp[data-ycp]'), init);
})();